import baseAPI from "@/api/base";
import {
  CreateDialerSession,
  DialerSessionsListParams,
  SetDialerPresence,
  SubmitDialerWrapup,
  UpdateDialerSessionAIAssistant,
} from "@/dtos/Dialer.dto";
import {
  CREATE_DIALER_SESSION_URL,
  DELETE_DIALER_SESSION_URL,
  END_DIALER_SESSION_URL,
  GET_ACTIVE_DIALER_SESSION_URL,
  GET_DIALER_PRESENCE_URL,
  GET_DIALER_SESSIONS_URL,
  PAUSE_DIALER_SESSION_URL,
  RESUME_DIALER_SESSION_URL,
  SET_DIALER_PRESENCE_URL,
  SUBMIT_DIALER_WRAPUP_URL,
  UPDATE_DIALER_SESSION_AI_ASSISTANT_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Dialer {
  static getPresence = async (): Promise<AxiosResponse> => {
    return await baseAPI.get(GET_DIALER_PRESENCE_URL);
  };

  static setPresence = async (data: SetDialerPresence): Promise<AxiosResponse> => {
    return await baseAPI.post(SET_DIALER_PRESENCE_URL, data);
  };

  static createSession = async (data: CreateDialerSession): Promise<AxiosResponse> => {
    return await baseAPI.post(CREATE_DIALER_SESSION_URL, data);
  };

  static getActiveSession = async (): Promise<AxiosResponse> => {
    return await baseAPI.get(GET_ACTIVE_DIALER_SESSION_URL);
  };

  static getSessions = async (params?: DialerSessionsListParams): Promise<AxiosResponse> => {
    return await baseAPI.get(GET_DIALER_SESSIONS_URL, { params });
  };

  static getSessionById = async (id: string): Promise<AxiosResponse> => {
    return await baseAPI.get(`${GET_DIALER_SESSIONS_URL}/${id}`);
  };

  static pauseSession = async (): Promise<AxiosResponse> => {
    return await baseAPI.post(PAUSE_DIALER_SESSION_URL);
  };

  static resumeSession = async (): Promise<AxiosResponse> => {
    return await baseAPI.post(RESUME_DIALER_SESSION_URL);
  };

  static updateSessionAIAssistant = async (
    data: UpdateDialerSessionAIAssistant
  ): Promise<AxiosResponse> => {
    return await baseAPI.patch(UPDATE_DIALER_SESSION_AI_ASSISTANT_URL, data);
  };

  static endSession = async (): Promise<AxiosResponse> => {
    return await baseAPI.post(END_DIALER_SESSION_URL);
  };

  static deleteSession = async (id: string): Promise<AxiosResponse> => {
    return await baseAPI.delete(`${DELETE_DIALER_SESSION_URL}/${id}`);
  };

  static submitWrapup = async (data: SubmitDialerWrapup): Promise<AxiosResponse> => {
    return await baseAPI.post(SUBMIT_DIALER_WRAPUP_URL, data);
  };
}

export default Dialer;
